<template>
    <div>
        <div class="pop_open ms-2" @click="showModal" data-bs-toggle="modal" data-bs-target="#backtype" >
            <div class="info_icon">
                <SvgHeaderSvg :type="'info'" />
            </div>
        </div>

        <Teleport  to="#teleports"> 
          <div class="modal fade" id="backtype" data-bs-backdrop="true" tabindex="-1" aria-labelledby="backtypeLabel" aria-hidden="true">
              <div class="modal-dialog modal-lg">
                <div class="modal-content">
                  <div class="title_block">
                      <div>
                          <!-- <h3 class="mb-0" v-font="$getFont('NewYork', 600)">Get a gemologist opinion</h3> -->
                          <!-- <p>Prong tips are those small metal balls (either rounded, pointed, or split in two) on the surface of the diamond. There may be three, four, five, six, or eight prong tips holding your diamond in place depending on your design. All our designs come with white color prong tips by default. You can choose the color of the tip of your prong as per your preference.</p> -->
                      </div>
                      <span data-bs-dismiss="modal" aria-label="Close"><SvgHeaderSvg :type="'close'" class="largesvg" /></span>
                  </div>
                  <div class="modal-body">
                  <div class="row">
                    <div class="col-md-12 col-12 mb-5">
                      <h3 class="mb-0 font-active">Back Type</h3>
                    </div>

                    <div class="col-md-6 col-12 mb-5 text-center">
                      <img class="mx-auto" width="400" height="400" src="https://assets.friendlydiamonds.com/fdl/fd_gif/push_video.gif">
                      <h5 class="text-center mb-2 font-active">Push Back</h5>
                      <p class="text-center">Push backs are often most commonly used with stud earrings. The earring back pushes straight right through the post of the earring making it very easy to use. It has a snug fit and it ensures your earrings stay in place.</p>
                    </div>

                    <div class="col-md-6 col-12 mb-5 text-center">
                      <img class="mx-auto" width="400" height="400" src="https://assets.friendlydiamonds.com/fdl/fd_gif/screw_video.gif">
                      <h5 class="text-center mb-2 font-active">Screw Back</h5>
                      <p class="text-center">Screw backs have a kind of winding groove on the post of the earring. One can twist the back around the post in multiple circular notions to tighten or loosen the earrings. This makes it difficult for the back to fall off on its own making it a more secure option.</p> 
                    </div>
                  </div>
                  </div>             
                </div>
              </div>
          </div>
        </Teleport>
    </div>
</template>

<script setup>

</script>

<style scoped>
.largesvg {
    transform: scale(1.3);
    }

.pop_open{
    color: #cccccc;
    font-size: 14px;
    cursor: pointer;
}

.modal-content{
    padding: 16px;
}
span{
    padding: 1%;
    color: #ccc;
    font-size: 14px;
    
}
  .gemo_box{
      cursor: pointer;
  }
  .title_block{
    /* display: flex;
    align-items: flex-start;
    justify-content: space-between; */
    text-align: right;
  }
  .modal-body {
    padding: 0 12px;
  }
  p {
    font-size: 16px;
    margin-bottom: 0;
    padding-top: 9px;
    color: #606060;
    font-weight: 400
}
  .title_block span {
      cursor: pointer;
  }
   h3{
      font-size: 24px;
      text-align: center;
      color: #212529;
  }

  h5 {
    color: #212529;
  }
  .drop_hint{
    cursor: pointer;
  }
  @media(max-width: 767px){
    h5{
        font-size: 16px;
    }
    p {
      font-size: 14px;
    }
  }
</style>
